import React, { Fragment, useMemo } from 'react'

import CardVideo from 'Root/App/Card/Content/Type/Video/Player'
import CoverImage from 'Root/App/CoverImage'
import Paragraph from 'Root/App/Paragraph'
import PreTitle from 'Root/App/PreTitle'
import List from 'Root/App/Tag/List'
import Title from 'Root/App/Title'
import { getTrackingProps } from 'lib/media-events-tracking'
import mixpanelTrack from 'lib/mixpanel-track'
import { secondsToDuration } from 'lib/seconds-to-duration'
import { useCurrentUserId } from 'lib/use-current-user-id'
import filter from 'lodash/filter'
import isFinite from 'lodash/isFinite'
import join from 'lodash/join'

import BottomContent from '../BottomContent'
import GoToLinkArea from './GoToLinkArea'

const TopContent = ({ content, setIsCompleted = () => {} }) => {
  const type = content.__typename
  const filtered = filter([
    content.label || (type === 'LinkContent' ? content.domain : null),
    'duration' in content && isFinite(content.duration)
      ? secondsToDuration(content.duration)
      : null,
  ])

  const userId = useCurrentUserId()

  const hasCover =
    !['AudioContent', 'VideoContent'].includes(type) && Boolean(content.cover)

  const handleVideoInteraction = (interaction) =>
    mixpanelTrack('Interazione con il video', {
      azione: interaction,
      id_video: content.slug,
      nome_video: content.title,
      id_corso: 'N/A',
      nome_corso: 'N/A',
    })

  const playerMemo = useMemo(
    () => (
      <CardVideo
        cover={content.cover}
        coverDimensions={content.coverDimensions}
        id={content.id}
        url={content.url}
        aspectRatio={content.aspectRatio}
        setIsCompleted={setIsCompleted}
        onVideoInteraction={handleVideoInteraction}
      />
    ),
    []
  )

  return (
    <Fragment>
      {type === 'AudioContent' && (
        <audio
          className="mt-5 rounded-md max-w-full w-full"
          controls
          controlsList="nodownload"
          id={`${content.id}_audio`}
          preload="auto"
          src={content.url}
          title={content.url}
          {...getTrackingProps(content.id, userId, setIsCompleted)}
        >
          <p>
            Your browser does not support the <code>audio</code> element.
          </p>
        </audio>
      )}
      {type === 'VideoContent' && (
        <div className="flex flex-col gap-3">{playerMemo}</div>
      )}
      {hasCover && (
        <GoToLinkArea content={content}>
          <CoverImage
            imageUrl={content.cover}
            dimensions={content.coverDimensions}
          />
        </GoToLinkArea>
      )}
      <div className="flex flex-col gap-y-3 p-6">
        <GoToLinkArea content={content}>
          <div className="flex flex-col gap-y-3">
            <PreTitle className="-mb-1">{join(filtered, ' · ')}</PreTitle>
            <Title maxRows={3}>{content.title}</Title>
            {Boolean(content.description) && (
              <Paragraph>{content.description}</Paragraph>
            )}
          </div>
        </GoToLinkArea>
        <List tags={content.tags} />
        <BottomContent content={content} />
      </div>
    </Fragment>
  )
}

export default TopContent
